import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { ICerere } from '../../cereri.interface';
import { EditSubsemnatComponent } from './edit-subsemnat/edit-subsemnat.component';
import { EditProgramareConfigComponent } from './edit-programare-config/edit-programare-config.component';
import { RescheduleProgramareComponent } from './reschedule-programare/reschedule-programare.component';
import { MatDialog } from '@angular/material/dialog';
import { PermissionsService } from 'src/app/services/permissions.service';
import { helper } from 'src/environments/helper';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-subsemnat',
    templateUrl: './subsemnat.component.html',
    styleUrls: ['./subsemnat.component.scss'],
})
export class SubsemnatComponent {
    @Input() cerere!: ICerere;
    @Output() cerereChanged: EventEmitter<ICerere> = new EventEmitter<ICerere>();
    selectedSubsemnatulStatus = 'info';

    helper = helper;

    constructor(
        public dialog: MatDialog,
        public permissionsService: PermissionsService,
        public toastr: ToastrService,
    ) { }

    onSubsemnatulInfoChange(event: MatButtonToggleChange) {
        this.selectedSubsemnatulStatus = event.value;
    }

    formatDate(date: string): string {
        return new Date(date).toLocaleString('ro-RO');
    }

    openEditSubsemnat() {
        const dialogRef = this.dialog.open(EditSubsemnatComponent, {
            width: '600px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                cerereData: this.cerere,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.cerereChanged.emit();
                this.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Date programare actualizate cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openEditProgramareConfig() {
        const dialogRef = this.dialog.open(EditProgramareConfigComponent, {
            width: '500px',
            maxWidth: '90vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                cerereData: this.cerere,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.cerereChanged.emit();
                this.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Configurația programării actualizată cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openRescheduleProgramare() {
        const dialogRef = this.dialog.open(RescheduleProgramareComponent, {
            width: '850px',
            maxWidth: '95vw',
            minHeight: '500px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data: {
                cerereData: this.cerere,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.cerereChanged.emit();
                this.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: 'Programarea a fost reprogramată cu succes',
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }
}
